export const preExceptionStatusCodeMap = {
    'PENDING': 1,
    'WAITING': 2,
    'APPROVED': 3,
    'DENIED': 4,
    'CANCELLED': 5,
}
